export const HIGH_MINIMUM_EUR = 10000;
// Read the first explicitly denominated euro amount, never a class ceiling,
// percentage, date, or a number from explanatory text without a currency.
export function minimumAmount(fund) {
  if (!fund?.fieldSources?.minimum?.url || typeof fund.minimum !== 'string') return null;
  const match = /(?<![\d.,])\d+(?:[.\s]\d{3})*(?:,\d{1,2})?\s*(?:EUR\b|eura\b|€)/iu.exec(fund.minimum);
  if (!match) return null;
  const amount = Number(match[0].replace(/EUR|eura|€/giu,'').replace(/[.\s]/g,'').replace(',','.'));
  return Number.isFinite(amount) ? {amount,start:match.index,end:match.index+match[0].length} : null;
}
export const hasHighMinimum = fund => (minimumAmount(fund)?.amount ?? 0) >= HIGH_MINIMUM_EUR;
const euro = new Intl.NumberFormat('hr-HR', { maximumFractionDigits: 2 });
// Short label for list rows, e.g. "Min. 300.000 €"; null below the threshold.
export function highMinimumLabel(fund) {
  if (!hasHighMinimum(fund)) return null;
  return `Min. ${euro.format(Math.floor(minimumAmount(fund).amount))} €`;
}
export const HIGH_MINIMUM_NOTE = 'Visok početni ulog. Fond nije prilagođen manjim, početnim ulaganjima; za manje iznose usporedite fondove niže minimalne uplate.';
